import { FC, ReactNode } from 'react';
import { Anchor } from '@/components/ui/Anchor';
import { Navigator, Body, Item } from '@/components/ui/Navigator';
import styles from './Navi.scss';

const items = [
  { key: 'date_on', label: '実施年月日' },
  { key: 'office', label: '適用事業所' },
  { key: 'health_checkup_institution', label: '健康診断実施機関' },
  { key: 'medical_history', label: '既往歴及び業務歴の調査' },
  { key: 'symptoms', label: '自覚症状及び他覚症状の有無の検査' },
  { key: 'height', label: '身長' },
  { key: 'weight', label: '体重' },
  { key: 'abdominal_circumference', label: '腹囲' },
  { key: 'vision', label: '視力', sub: ['vision_left', 'vision_right'] },
  {
    key: 'hearing',
    label: '聴力',
    sub: ['1000hz', '4000hz', 'other'].flatMap(category => [
      `hearing_${category}`,
      `hearing_${category}_left`,
      `hearing_${category}_right`
    ])
  },
  { key: 'chest_x_ray', label: '胸部エックス線検査' },
  { key: 'sputum_test', label: '喀痰検査' },
  { key: 'blood_pressure', label: '血圧' },
  { key: 'anemia_test', label: '貧血検査' },
  { key: 'liver_function_test', label: '肝機能検査' },
  { key: 'blood_lipid_test', label: '血中脂質検査' },
  { key: 'blood_sugar_test', label: '血糖検査' },
  { key: 'urine', label: '尿検査', sub: ['urine_sugar', 'urine_protein'] },
  { key: 'electrocardiogram', label: '心電図検査' },
  { key: 'order_by_doctor', label: '医師の指示対象' },
  { key: 'specified_works', label: '労働安全衛生規則第13条第１項第３号に掲げる業務' },
  { key: 'report', label: '健康診断結果ファイル' }
];

interface NaviProps {
  children?: ReactNode;
}

export const Navi: FC<NaviProps> = ({ children }) => (
  <Navigator className={styles.navigator}>
    <Body className={styles.body}>
      <div className={styles.items}>
        {items.map(({ key, label, sub }) => (
          <Item key={key} className={styles.item}>
            <Anchor name={key} sub={sub}>
              {label}
            </Anchor>
          </Item>
        ))}
      </div>
      <Item className={styles.submitItem}>{children}</Item>
    </Body>
  </Navigator>
);
